import { Stack } from '@mui/system';
import { getSelectedBoardId } from '@common-reducers/BoardsSelectors';
import { DBBoardViewThunks, boardViewSelectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { useMemo } from 'react';
import BTCheckboxList from '../checkbox-list/bt-checkbox-list';
import { getDynamicColumnListForBTCheckbox } from '@common-reducers/TaskSelectors';
import { TaskColumn } from '@common-models/task-column';

export default function BoardViewIncludedColumnsDialog() {
    const dispatch = useAppDispatch()
    const currentBoardId = useAppSelector(getSelectedBoardId)
    const currentBoardView = useAppSelector((state) => state.TasksReducer.currentBoardView)
    const [boardView] = useAppSelector((state) => boardViewSelectByQuery(state.DBBoardViewReducer, { boardId: currentBoardId, _id: currentBoardView.id }));
    const columnList = useAppSelector((state) => getDynamicColumnListForBTCheckbox(state, 'board'))
    const includedColumns = useMemo(() => (boardView && boardView?.includedColumns ? boardView?.includedColumns : {}), [boardView])
    const handleCheckBoxChange = (value: boolean, column: TaskColumn) => {
        if (!boardView) return;
        const colKey = column._id ?? '';
        dispatch(
            DBBoardViewThunks.patch({
                entity: {
                    _id: boardView._id,
                    includedColumns: {
                        ...boardView.includedColumns,
                        [colKey]: value,
                    }
                }
            })
        )

    }

    function handleAllCheckBoxChange(value: boolean) {
        if (!boardView) return;
        const newIncludedColumnsList = columnList.map((column) => ({
            id: column._id, boolean: value
        }))
        let newIncludedColumns: Record<string, boolean> = {}
        for (let i in newIncludedColumnsList) {
            const entry = newIncludedColumnsList[i];
            if (entry.id) {
                newIncludedColumns = {
                    ...newIncludedColumns,
                    [entry.id]: entry.boolean
                }
            }
        }

        dispatch(
            DBBoardViewThunks.patch({
                entity: {
                    _id: boardView._id,
                    includedColumns: newIncludedColumns,
                }
            })
        )
    }

    const isChecked = (column: TaskColumn) => (includedColumns[column._id ?? ''] ?? false)

    const isCheckedRecord: Record<string, boolean> = columnList.reduce<Record<string, boolean>>((isCheckedRecord, column) => ({
        ...isCheckedRecord,
        [column._id ?? '']: isChecked(column)
    }), {});

    return (
        <Stack direction="column" >
            <BTCheckboxList
                isCheckedRecord={isCheckedRecord}
                columnList={columnList}
                handleCheckBoxChange={handleCheckBoxChange}
                handleAllCheckBoxChange={handleAllCheckBoxChange}
            />
        </Stack>
    )
}
